export const screenSize = {
    mobile: '(max-width: 576px)',
    tablet: '(max-width: 768px)',
}
